// extracted by mini-css-extract-plugin
module.exports = {"container":"settings_container__34g4u"};